import React, { Component, Fragment } from 'react'
import { UtilityService } from '../../services'
import Field from '../Common/Field/Field';
import QrCode from '../Common/QrCode';
import utilityService from '../../services/utility.service';
import Modal from 'react-responsive-modal';

class TrimSidebar extends Component {
    
    state = {
        number : '',
        qr : '',
        image : "",
        HSN : '',
        moduleName : '',
        hsnOptions : [],
        openmodal : false,
        disabled : false
    }

    componentWillMount () {
        const {
            number,
            qr,
            image,
            HSN,
            handleImageUpload, //IMAGE UPLOAD
            hsnOptions,      //HSN OPTIONS
            moduleName,
            disabled
        } = this.props;
        this.setState({
            number,
            qr,
            image,
            HSN,
            handleImageUpload, //IMAGE UPLOAD
            hsnOptions,      //HSN OPTIONS
            moduleName,
            disabled
        })
    }

    componentWillReceiveProps (nextProps) {
        if(this.props !== nextProps ){
            const {
            number,
            qr,
            image,
            HSN,
            handleImageUpload, //IMAGE UPLOAD
            hsnOptions,      //HSN OPTIONS
            moduleName,
            disabled
        } = nextProps;
        this.setState({
            number,
            qr,
            image,
            HSN,
            handleImageUpload, //IMAGE UPLOAD
            hsnOptions,      //HSN OPTIONS
            moduleName,
            disabled
        })}
    }

    openModal = (e) => {
        
    if(this.state.image != "" &&  e.target.id  != 'editfile'){
        this.setState({
            openmodal : true
        })
     }
    }

    onClose = () => {
        this.setState({
            openmodal : false
        })
    }

    render() {
        const {
            number,
            qr,
            image,
            HSN,
            handleImageUpload, //IMAGE UPLOAD
            hsnOptions,      //HSN OPTIONS
            moduleName,
            disabled
        } = this.state;

        return (

            <div className="left-content-section no-padding">

                <div className="col text-center bg-color padding-bottom-bg">

                    {/* HEADING START HERE */}

                    <h4 className="text-green font-lg font-weight-bold mt-2">

                        {number !== null && number !== '' ?  number : ''}

                    </h4>
                    {/* HEADING END HERE */}

                    {/* IMAGE UPLOAD SECTION START*/}

                    <div id="opendiv" className="img-responsive-fill border-1 inputWrapper mt-2" onClick = {(e) =>this.openModal(e)}>
                        <span className="positioing-end">
                        { !disabled ? image !== undefined && image !== null && image !== '' &&
                                    image
                                    ?
                            <a className="pull-right p-1">
                            <input
                                id="editfile"
                                type="file"
                                className="fileInputs"
                                accept="image/*" 
                                onChange={(e) => handleImageUpload(e)}
                            />
                                 <i className="fa fa-edit icon-fa-color print-hidden"></i>
                            </a> :
                            <a className="pull-right p-1" >
                            <input
                                id="add"
                                type="file"
                                className="fileInputs"
                                accept="image/*" 
                                onChange={(e) => handleImageUpload(e)}
                            />
                            <i className="fa fa-plus-circle icon-fa-color print-hidden"></i>
                            </a> : null
                        }
                        </span>

                        {
                            image !== undefined && image !== null && image !== '' &&
                                image //SHOWING THIS LABEL WHEN FILE WAS'nt uploaded
                                ? <img src={utilityService.fileUrl()+image} />
                                : <div className="d-flex  align-items-center justify-content-center h-100">
                                    <span className="font-sm">Add {moduleName} Image</span>
                                </div>
                        }

                        {/* IMAGE UPLOAD */}

                       {/* {!this.props.disabled && <input
                            type="file"
                            className="fileInputs"
                            onChange={(e) => handleImageUpload(e)}
                        />
                        } */}
                        { !disabled && <span className="positioing-bottom" onClick ={(e) => { e.stopPropagation(),this.props.removeFabricImage()}}>
                            <a className="pull-right p-1" >
                                {image !== undefined && image !== null && image !== '' &&
                                    image
                                    ? <i className="fa fa-trash icon-fa-color print-hidden"></i>
                                    : ''
                                }
                            </a>
                        </span>}
                    </div>

                    {/* IMAGE UPLOAD SECTION END */}

                    {/* HSN START*/}

                    <div className="mt-2  p-0">
                        
                        
                        <div className="input-group">
                            <div className="input-group-prepend text-green mr-1">
                                HSN
                            </div>

                            {/* HSN SELECT */}
                            <Field
                                isFormGroup={false}
                                inputType='select'
                                inputName='HSN'
                                value ={HSN}
                                options={hsnOptions}
                                onChange={this.props.getFabricData}
                                disabled={this.props.disabled}
                            />

                            {/* DEFAULT LINK */}

                            <div class="input-group-append text-center d-inline-block ml-1">
                                <span class="input-group-text">
                                    <a className="apply-color-a"
                                        href="https://www.google.com"
                                        target="_blank"
                                    >
                                        <i className="fa fa-exclamation-circle"></i>
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* HSN END */}
                    
                    {qr != '' &&<QrCode
                        qr = {qr}
                    />}

                </div>

            <Modal open={this.state.openmodal} onClose={this.onClose} center>
                    <img src={UtilityService.fileUrl()+image}/>
            </Modal>
            </div>
        );
    }
}

export default TrimSidebar;

/*
DOCUMENTATION
 PROPS:
    heading:''(STRING)





*/


// WEBPACK FOOTER //
// ./src/components/TrimSidebar/index.js